import { axios } from '@/api/axios.ts';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import type {
  TClientAttribute,
  TClientAttributeRequest,
  TClientAttributeUpdateRequest,
  TClientAttributeResponse,
} from './client-attribute-details.types.ts';

export const clientAttributeDetailsApi = {
  getClientAttributeDetails: async () => {
    const response = await axios.get<TClientAttribute[]>(`client-attribute-details`);

    return response.data;
  },
  getClientAttributeDetailsID: async (id: number) => {
    const response = await axios.get<TClientAttribute>(`client-attribute-details/${id}`);

    return response.data;
  },
  createClientAttributeDetails: async (clientAttribute: TClientAttributeRequest) => {
    const response = await axios.post<TClientAttributeResponse>(
      `client-attribute-details`,
      clientAttribute,
    );

    return response.data;
  },
  updateClientAttributeDetails: async (payload: {
    id: number;
    clientAttribute: TClientAttributeUpdateRequest;
  }) => {
    const { id, clientAttribute } = payload;

    const response = await axios.patch<TClientAttributeResponse>(
      `client-attribute-details/${id}`,
      clientAttribute,
    );

    return response.data;
  },
  deleteClientAttributeDetails: async (id: number) => {
    const response = await axios.delete<TClientAttributeResponse>(`client-attribute-details/${id}`);

    return response.data;
  },
};

export const clientAttributeDetailsQueries = createQueryKeys('client-attribute-details', {
  getClientAttributeDetails: () => ({
    queryKey: ['list'],
    queryFn: () => clientAttributeDetailsApi.getClientAttributeDetails(),
  }),
  getClientAttributeDetailsID: (id: number) => ({
    queryKey: ['attribute-detail', id],
    queryFn: () => clientAttributeDetailsApi.getClientAttributeDetailsID(id),
  }),
});
